import React from "react";
import { ArrowUp, ArrowDown } from "react-bootstrap-icons";
import { Card, Col, ProgressBar, Row } from "react-bootstrap";

function SummaryBoxCard(props) {
  const numericChange = Number(props.PercentageChange);
  const hasChange = !isNaN(numericChange) && props.PercentageChange !== undefined && props.PercentageChange !== null;

  let arrow;
  let color;
  let variant;

  if (hasChange && numericChange > 0) {
    arrow = <ArrowUp color="green" />;
    color = "green";
    variant = "success";
  } else if (hasChange && numericChange < 0) {
    arrow = <ArrowDown color="red" />;
    color = "red";
    variant = "danger";
  } else {
    arrow = "-";
    color = "black";
    variant = "secondary";
  }

  const progressValue = hasChange ? Math.min(Math.abs(numericChange), 100) : 0;

  return (
    <div>
      <Card>
        <Card.Body>
          <h6>{props.label}</h6>
          <Row className="mb-1">
            <Col md={8}>
              <h4>{props.value}</h4>
            </Col>
            <Col md={4} className="text-right">
              <span
                className="pull-end"
                style={{ whiteSpace: "nowrap", float: "right" }}
              >
                {arrow}
                <small style={{ color }}>{hasChange ? `${props.PercentageChange}%` : ""}</small>
              </span>
            </Col>
          </Row>
          <ProgressBar striped variant={variant} now={progressValue} />
        </Card.Body>
      </Card>
    </div>
  );
}

export default SummaryBoxCard;
